import { SpinnerArea } from 'components/spinner/SpinnerArea';
import { useUser } from 'contexts/UserContext';
import { ReactNode, Suspense } from 'react';
import { Redirect, RouteProps } from 'react-router-dom';

export type ProtectedContentProps = Omit<RouteProps, 'path' | 'component' | 'render'> &
    Readonly<{
        /**
         * The name of the page used for Application Insights.
         */
        pageName: string;
        /**
         * Children to be rendered if user has a token.
         */
        children: ReactNode;
    }>;

/**
 * Component the renders the children when the user is logged in,
 * otherwise redirects to the login page.
 */
// TODO @JP [PENDO-ROUTE-TRACK]: ask Corey if there'd be any benefit to wiring
// this up, othewise remove `pageName`
// ---
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function ProtectedContent({ pageName, children }: ProtectedContentProps) {
    const user = useUser();

    return user.token ? (
        <Suspense fallback={<SpinnerArea />}>{children}</Suspense>
    ) : (
        <Redirect to="/login" />
    );
}
